export const NAV_UPGRADE_SOURCE = 'global-nav-bar';